import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';

@Component({
  selector: 'app-course-complettion',
  templateUrl: './course-complettion.component.html',
  styleUrls: ['./course-complettion.component.scss']
})
export class CourseComplettionComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, private spinner: NgxSpinnerService, private appService: AppService,
    public dialogRef: MatDialogRef<CourseComplettionComponent>, private router: Router) {
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }
  onCancel() {
    this.dialogRef.close()
  }
  onExam() {
    let data = {
      p_i: this.dialogData.p_i,
      c_i: this.dialogData.c_i,
      a_o: 'y',
      e_t: this.dialogData.e_t,
    }
    let exam_type: string = "overall"
    this.dialogRef.close({ data, exam_type })

    //  this.router.navigate(['/individual/my-course/exam-list'],{ queryParams: data })
  }
}
